module.exports = "<ng-container cdkPortalOutlet></ng-container>\r\n"